import { IFilter } from "./filtering";

export interface IUserInfo {
    userName?: string | null;
    userFullName?: string | null;
    phone?: string | null;
    profilePicturePath?: string | null;
    extraVariables: any;
}

export interface IPanelMessage {
    id: number;
    rowGuid: any;
    content: string;
    link?: string;
}

export interface IPanelInfo {
    data: { key: string; Message?: string; Id?: number; RowGuid: any; Path: string; }[];
}

export interface IComponentItem {
    Id: string;
    ParentId?: string;
    Path?: string;
    Item?: string;
    Title: string;
    Icon?: string;
}

export enum enmEntityState {
    Unchanged = 0,
    Added = 1,
    Modified = 2,
    Deleted = 3
}

export interface IEntity {
    Id: number;
    RowGuid: string;
    RowVrsn?: any;
    CreatorId: number;
    CreateDateTime: Date;
    IsDeleted?: boolean;
    State: enmEntityState;
    ModifiedProperties: string[];
}

export enum enmValidationLevel {
    Info = 0,
    Warning = 1,
    Error = 2,
    Exception = 3,
    Unauthorized = 4,
    AccessDenied = 5,
    ResetPassword = 6,
    FirstLogin = 7
}

export interface IValidationResult {
    Message?: string;
    Level: enmValidationLevel;
    RowGuid: string;
    PropertyName: string;
}

export interface IValidationState {
    Successful: boolean;
    ValidationResults: IValidationResult[];
}

export interface IResult {
    ValidationState: IValidationState;
}

export interface IResultSet<T> extends IResult {
    Data?: T;
}

export interface IFetchingResult<T> extends IResult {
    TotalResultCount: number;
    Data?: T[];
}

export enum enmOrderingType {
    Ascending = 0,
    Descending = 1
}

export interface IPaging {
    PageNo: number;
    PageSize: number;
}

export interface IOrdering {
    Property: string;
    OrderBy: enmOrderingType;
}

export interface IFetchingInfo {
    Filter?: IFilter;
    Paging?: IPaging;
    Orderings: IOrdering[];
    FetchingDetails?: boolean;
}

export interface ICallOptions {
    tryCount?: number;
    url: string;
    data?: any;
    onSuccess?: (result: IResult) => void;
    onError?: (error: any) => void;
    onComplete?: () => void;
    withBlock?: boolean;
    withBlockTitle?: string;
    headers?: { key: string; value: string; }[];
    contentType?: boolean;
}
